import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './components/home/home.component';
import { PrincipalComponent } from './components/principal/principal.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule, AngularFirestoreCollection, AngularFirestoreDocument } from "@angular/fire/firestore";
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FormsModule  } from "@angular/forms";     
import { DataTablesModule } from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { FilterPipe } from './pipes/filter.pipe';

const firebaseConfig = {
  apiKey: "AIzaSyCZQv1i_Ghg_uAn6cyCstlVpv52qkr8-NQ",
  authDomain: "aqui-me-atienden.firebaseapp.com",
  databaseURL: "https://aqui-me-atienden.firebaseio.com",
  projectId: "aqui-me-atienden",
  storageBucket: "aqui-me-atienden.appspot.com",
  messagingSenderId: "189181957039",
  appId: "1:189181957039:web:e8e23e652613bdc433155a",
  measurementId: "G-KPQ0BW0MQY"
};
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FilterPipe,
    PrincipalComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    DataTablesModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDpdxJabo9anY2K_UCDDFapjrV5a3RC7nM'    
   })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
